import React from "react";
import { useLang } from "@/lib/i18n";
import SeoLandingPage from "@/components/SeoLandingPage";
import { certificaatbeheerNL } from "@/data/seo-landing-pages";

const CertificaatbeheerWagenpark = () => {
  const { lang } = useLang();
  return <SeoLandingPage data={certificaatbeheerNL} lang={lang} />;
};

export default CertificaatbeheerWagenpark;
